module.exports = __webpack_public_path__ + "static/future-shock-ba4bda34f3e31319ffb0db707991417d.jpg";